import React from 'react'
const Wikipedia = props => {
  // props for this file from another
  const { wikipediaURL, error, handleWikipediaURLChange } = props
  return (
    <div>
      <label>
        Wikipedia URL<div className='mandatory'>*</div>
      </label>
      {/* input field to enter wikipedia url */}
      <input
        type='url'
        name='wikipedia'
        className='form-control'
        value={wikipediaURL}
        disabled={props.disableInput === true}
        // on handleWikipediaURLChange function passed as props is trigred
        onChange={handleWikipediaURLChange}
        style={{ width: '49%' }}
      />
      {/* if the url field is empty it show error */}
      {error.wikipediaURL && (
        <div className='mandatory1'>
          <span>{error.wikipediaURL}</span>
        </div>
      )}
    </div>
  )
}

export default Wikipedia
